// Tree columns list the user's favorites (starred nodes) as a group of their own
// above the remaining nodes. The server already sorts them first (`starredAtTop`),
// but the split happens here on `isStarred`: a star toggled in a row, the column
// header or the detail panel updates the normalized node right away, so the row
// moves without refetching the column (which would drop its "Show more" pages).
// The pinned selection is left out of both groups — it is rendered above them
// and must not show twice once "Show more" loads its page.

export interface ColumnNodeGroups<T> {
    favorites: T[];
    others: T[];
}

export const groupColumnNodes = <T extends { id: string; isStarred?: boolean | null }>(
    nodes: T[],
    pinnedNodeId?: string | null
): ColumnNodeGroups<T> => {
    const favorites: T[] = [];
    const others: T[] = [];
    nodes.forEach((node) => {
        if (pinnedNodeId && node.id === pinnedNodeId) return;
        (node.isStarred ? favorites : others).push(node);
    });
    return { favorites, others };
};
